import { OIE_ENROLLED_FACTOR_CONFIG } from '../../../constants';
import { getLocalizedString } from '../../../utils/i18n-utils';
import CommonEnrollItem, { EnrollItemProps as CommonEnrollItemProps } from '../EnrollItem';

export interface EnrollItemProps extends Omit<CommonEnrollItemProps, 'factorDescription' | 'factorLabel' | 'oktaButton'> {
  oktaFactorItem: JQuery;
  lastItem: boolean;
  isEnrolledFactor: boolean;
}

export default function EnrollItem({ oktaFactorItem, lastItem, isEnrolledFactor }: Readonly<EnrollItemProps>) {
  const labelElement = oktaFactorItem.find('h3');
  const description = oktaFactorItem.find('p').eq(0);

  const oktaButtonContainer = oktaFactorItem.find('.authenticator-button');

  const dataSe = oktaButtonContainer.data('se') as keyof typeof OIE_ENROLLED_FACTOR_CONFIG;
  const { labelI18nKey } = OIE_ENROLLED_FACTOR_CONFIG[dataSe] ?? {};

  const finalLabel = getLocalizedString(labelI18nKey) ?? labelElement.text();

  const oktaButton = oktaButtonContainer.find('a.button');

  return (
    <CommonEnrollItem
      oktaFactorItem={oktaFactorItem}
      factorLabel={finalLabel}
      factorDescription={description.text()}
      oktaButton={oktaButton}
      lastItem={lastItem}
      isEnrolledFactor={isEnrolledFactor}
    ></CommonEnrollItem>
  );
}
